import { assetSideMenuSize } from 'src/app/consts';

export const feedbackButtonSizes: { [propName: string]: { small: number; full: number } } = {
  favourite: { small: 72, full: 160 },
  flag: { small: 90, full: 185 },
  color_label: { small: 62, full: 160 },
  comment_with_sidebar: { small: 76, full: 153 },
  comment: { small: 40, full: 135 },
  annotation: { small: 40, full: 118 },
};

const getTotalDisplaySize = (
  display: { [propName: string]: 'full' | 'small' },
  disabledFeedbackItems: { icon: string; option: string; name: string }[],
  sidebarOpen: boolean
) => {
  const spacing = 5 * 2; // margin around each button
  let total = 0;
  for (const key in display) {
    let k = key;
    if (key === 'comment' && sidebarOpen) k = 'comment_with_sidebar';
    total += feedbackButtonSizes[k][display[key]];
    total += spacing;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  for (const _i in disabledFeedbackItems) {
    total += 40 + spacing;
  }
  return total - spacing;
};

export const fits = (
  display: { [propName: string]: 'full' | 'small' },
  disabledFeedbackItems: { icon: string; option: string; name: string }[],
  sidebarOpen: boolean
) => {
  const width = getTotalDisplaySize(display, disabledFeedbackItems, sidebarOpen);
  return width < window.innerWidth - 40 - (sidebarOpen ? assetSideMenuSize : 0);
};
